import Projects from '../components/projects.svelte';

const { $ } = window

export default {
	init() {
    let $projects = $('#projects-wrap')
    if ($projects.length)
      new Projects({
        target: $projects[0],
        props: $projects.data()
      })
	},
	finalize() {
		// JavaScript to be fired on the services page, after the init JS
	},
}
